import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "switch",
  type: "checkbox"
}
const _hoisted_2 = ["value", "checked"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "switch-circle" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "switch-background" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("input", {
      type: "checkbox",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.changeColor && _ctx.changeColor(...args))),
      ref: "inputCheckbox",
      value: _ctx.value,
      class: "switch-input",
      checked: _ctx.value
    }, null, 8, _hoisted_2),
    _hoisted_3,
    _createElementVNode("div", {
      ref: "SwitchOn",
      class: _normalizeClass(["switch-on switch-text", { 'active-text': _ctx.value || _ctx.$attrs.checked }])
    }, [
      _renderSlot(_ctx.$slots, "on")
    ], 2),
    _createElementVNode("div", {
      ref: "SwitchOff",
      class: _normalizeClass(["switch-off switch-text", { 'active-text': !_ctx.value && !_ctx.$attrs.checked }])
    }, [
      _renderSlot(_ctx.$slots, "off")
    ], 2),
    _hoisted_4
  ]))
}